import React from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'formik';

const DateTimePicker=({
    name, ...otherProps
})=>{
    const [field, meta] = useField(name);    

   // const test=new Date()
    const configDateTimePicker={
        ...field,
        ...otherProps,
        type:'datetime-local',
        variant: 'outlined',
        fullWidth: true,
        inputProps: {
            max:"2199-12-30T00:00",
            min: otherProps.min
        },
        InputLabelProps:{
            shrink: true
        }
    }    

    if (meta && meta.touched && meta.error){
        configDateTimePicker.error=true;
        configDateTimePicker.helperText=meta.error;
    }

    return (
        <TextField {...configDateTimePicker}></TextField>
    )

}

export default DateTimePicker;